"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.IconButtons = exports.CloseButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
// pixels by which drawer overlaps the map
const DRAWER_OVERLAP = '10px';
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        backgroundColor: theme.palette.grey[200],
        cursor: 'pointer',
        display: 'flex',
        height: "calc(54% + ".concat(DRAWER_OVERLAP, ")"),
        left: 0,
        position: 'fixed',
        top: 0,
        transition: 'height 0.1s',
        width: '100%',
        zIndex: 1300,
        [theme.breakpoints.up('md')]: {
            height: '100%',
            maxWidth: 900,
            minWidth: 420,
            position: 'relative',
            zIndex: 'auto'
        }
    };
});
const IconButtons = exports.IconButtons = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        bottom: "calc(".concat(theme.spacing(3), " + ").concat(DRAWER_OVERLAP, ")"),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
        position: 'absolute',
        right: theme.spacing(3),
        zIndex: 999,
        // displayed under the selected details info
        [theme.breakpoints.up('md')]: {
            bottom: theme.spacing(3),
            display: 'flex'
        }
    };
});
const CloseButton = exports.CloseButton = (0, _mui.styled)(_components.Button)((param)=>{
    let { theme } = param;
    return {
        position: 'absolute',
        right: theme.spacing(3),
        top: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            right: theme.spacing(6),
            top: theme.spacing(6)
        }
    };
});
